import { createQueryKeys } from '@lukemorales/query-key-factory';
import type { UserStatusDto } from '@mfw/common/ui/dtos';
import { UserOrderBy } from '@mfw/common';

import type {
  FetchOrganizationClientsArgs,
  FetchOrganizationUserById,
} from '../api/types/user.types';

import {
  fetchOrganizationClientById,
  fetchOrganizationClients,
} from '../api/organization.clients.api';

export interface FetchInfiniteOrganizationClientsArgs {
  organizationId: string;
  statuses?: UserStatusDto[];
  search?: string;
  limit?: number;
}

export const organizationClientsQueryKeys = createQueryKeys(
  'organizationClients',
  {
    fetchInfiniteOrganizationClients: ({
      limit = 25,
      organizationId,
      search,
      statuses,
    }: FetchInfiniteOrganizationClientsArgs) => ({
      queryFn: (context: { pageParam?: unknown }) => {
        const page = parseInt((context?.pageParam as string) || '1', 10);
        return fetchOrganizationClients({
          limit,
          offset: page,
          orderBy: UserOrderBy.NAME,
          organizationId,
          search,
          statuses,
        });
      },
      queryKey: [organizationId, { limit, search, statuses }],
    }),
    fetchOrganizationClientById: (args: FetchOrganizationUserById) => ({
      queryFn: () => fetchOrganizationClientById(args),
      queryKey: [args.organizationId, args.id],
    }),
    fetchOrganizationClients: (args: FetchOrganizationClientsArgs) => ({
      queryFn: () => fetchOrganizationClients(args),
      queryKey: [args.organizationId, args],
    }),
  },
);
